import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { BrowserRouter as Router } from "react-router-dom";
import store from "redux/store";
import App from "./App";
import "./index.css";
import * as serviceWorker from "./serviceWorker";
import FeatureProvider from "./components/FeatureProvider";

ReactDOM.render(
  <FeatureProvider>
    <Provider store={store}>
      <Router>
        <App />
      </Router>
    </Provider>
  </FeatureProvider>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
